import MessageBodyIsDisplay from './MessageBodyIsDisplay'
import MessageBodyIsForm from './MessageBodyIsForm.container'
import IconTick from 'components/Icons/Tick'
import IconClose from 'components/Icons/Close'
import IconMessageBullet from 'components/Icons/MessageBullet'

export default {
  id: 'message_body_is',
  label: 'Message body is',
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/message-body-is',
  icon: IconMessageBullet,
  inputs: [{}],
  outputs: [
    {
      name: 'false',
      label: 'False',
      icon: IconClose,
    },
    {
      name: 'true',
      label: 'True',
      icon: IconTick,
    },
  ],
  display: MessageBodyIsDisplay,
  form: MessageBodyIsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/MessageBodyIs/index.js